(function () {
  'use strict';

  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: 'USD'
    }).format((Number(cents) || 0) / 100);
  }

  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var counter = root.querySelector('[data-gallery-current]');
    if (!main || !thumbs.length) return;
    var current = 0;
    function show(index) {
      current = (index + thumbs.length) % thumbs.length;
      main.src = thumbs[current].getAttribute('data-src');
      thumbs.forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === current); });
      if (counter) counter.textContent = String(current + 1);
    }
    thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { show(i); }); });
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    var startX = 0;
    main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      var distance = e.changedTouches[0].clientX - startX;
      if (Math.abs(distance) > 45) show(current + (distance < 0 ? 1 : -1));
    }, { passive: true });
  }

  function initCountdown(root) {
    var output = root.querySelector('[data-countdown-value]');
    if (!output) return;
    var key = 'gfouk_offer_end_' + window.location.pathname;
    var end = Number(localStorage.getItem(key));
    if (!end || end < Date.now()) {
      end = Date.now() + (30 * 60 * 1000);
      try { localStorage.setItem(key, String(end)); } catch (e) {}
    }
    function tick() {
      var seconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (seconds === 0) { end = Date.now() + (30 * 60 * 1000); }
      var minutes = Math.floor(seconds / 60);
      output.textContent = String(minutes).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
    }
    tick();
    window.setInterval(tick, 1000);
  }

  function updateVariant(root, radio) {
    root.querySelectorAll('[data-variant-card]').forEach(function (card) {
      card.classList.toggle('is-selected', card.contains(radio));
    });
    var id = root.querySelector('[data-variant-id]');
    if (id) id.value = radio.value;
    var price = radio.getAttribute('data-price-formatted') || money(radio.getAttribute('data-price'));
    var compare = radio.getAttribute('data-compare-formatted') || money(radio.getAttribute('data-compare'));
    var priceCents = Number(radio.getAttribute('data-price')) || 0;
    var compareCents = Number(radio.getAttribute('data-compare')) || priceCents;
    var save = compareCents > 0 ? Math.round((compareCents - priceCents) * 100 / compareCents) : 0;
    document.querySelectorAll('[data-product-price],[data-urgency-price],[data-mobile-price]').forEach(function (el) { el.textContent = price; });
    document.querySelectorAll('[data-product-compare],[data-mobile-compare]').forEach(function (el) { el.textContent = compare; });
    var urgencyCompare = root.querySelector('[data-urgency-compare]');
    if (urgencyCompare) urgencyCompare.textContent = '(Was ' + compare + ')';
    var saveEl = root.querySelector('[data-product-save]');
    if (saveEl) saveEl.textContent = 'SAVE ' + save + '%';
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', radio.value);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  function initProduct(root) {
    initGallery(root);
    initCountdown(root);
    root.querySelectorAll('input[name="bundle-choice"]').forEach(function (radio) {
      radio.addEventListener('change', function () { updateVariant(root, radio); });
    });
    root.querySelectorAll('[data-scroll-to]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = document.querySelector(button.getAttribute('data-scroll-to'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    var form = root.querySelector('#gfouk-product-form');
    var status = root.querySelector('[data-form-status]');
    if (!form || !window.fetch) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = form.querySelector('[data-add-to-cart]');
      var label = form.querySelector('[data-atc-label]');
      if (button) button.disabled = true;
      if (label) label.textContent = 'Adding…';
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
      }).then(function (response) {
        if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add this item.'); });
        return response.json();
      }).then(function () {
        if (status) status.textContent = 'Added to cart.';
        window.location.href = '/cart';
      }).catch(function (error) {
        if (status) status.textContent = error.message;
        if (button) button.disabled = false;
        if (label) label.textContent = 'Add to cart';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-root]').forEach(initProduct);
  });
})();
